import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { IMaterialDataUpdate } from 'src/app/state/material-data-update.model';
import { IMaterialMetadata } from 'src/app/state/material-metadata.model';

@Injectable({
  providedIn: 'root',
})
export class MaterialDataUpdateService {
  public constructor(private readonly httpClient: HttpClient) {}

  public setResponsibleUser(username: string, designId: string) {
    const materialDataUpdate: IMaterialDataUpdate = {
      ResponsibleUser: username,
    };

    return this.httpClient
      .patch(`api/material-data/responsible-user/${designId}`, materialDataUpdate)
      .pipe(rethrowAsSapError());
  }

  public getMaterialMetadata(materialNumbers: string[]): Observable<IMaterialMetadata[]> {
    const params = materialNumbers.reduce((agg, x) => {
      agg.append('materialNumbers', x);

      return agg;
    }, new URLSearchParams());

    return this.httpClient.get<IMaterialMetadata[]>(
      `api/material-data/metadata?${params.toString()}`
    );
  }
}
